export default "__VITE_ASSET__JD3dK3kY__"